import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../Assets/css/layout.css";
import { ReactComponent as ArrowUpSide } from "../Assets/svgs/upside-arrow.svg";
import { ReactComponent as ChatIcon } from "../Assets/svgs/chat-icon.svg";
import { Tooltip } from "@mui/material";
import Vimeo from "@u-wave/react-vimeo";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { useDispatch, useSelector } from "react-redux";

import {
  CMSDataSelector,
  setFooterData,
  setFooterDataError,
} from "../../redux/cmsData";
import { GetAllCMSData } from "../../services/cmsService";
import { loginItemsSelector } from "../../redux/login";
import ImageMenu from "./ImageMenu";
import StarsImageMenu from "../Screens/StarContent/StarsImageMenu";
import VideoMenu from "./VideoMenu";
import { GetMagnifiedImage } from "../../services/ImageInformation";
import { getDataFromAppSetting } from "../../lib/helper";
import { appSettingDataSelector } from "../../redux/appSetting";
import CarouselComponent from "./Carousel/CarouselComponent";
import ReactPlayer from "react-player";
import ApiConfig from "../../config/ApiConfig";

const Layout = ({
  hasBannerImage,
  children,
  isSearchtext,
  isMoreInfoWall,
  isStarsMoreInfo,
  isStarsCollectionPage,
  imageSno,
  shootId,
  isScrollDown,
  imageAlignment,
  FullImageWall,
  authUser,
  imageid,
  videoSno,
  videoid,
  isVideoMoreInfoWall,
}) => {
  const [showScroller, setShowScroller] = useState("none");
  const dispatch = useDispatch();
  const { isPrivilegeUser } = useSelector(loginItemsSelector);
  const { appSettingData } = useSelector(appSettingDataSelector);
  const [isMoreInfoImageError, setIsMoreInfoImageError] = useState(false);
  const [errorMoreInfoPage, setErrorMoreInfoPage] = useState("");

  const getCMSData = async () => {
    let payload = { pagename: "layout" };
    dispatch(GetAllCMSData(payload, setFooterData, setFooterDataError));
  };
  useEffect(() => {
    getCMSData();
  }, []);

  const { loading } = useSelector(CMSDataSelector);
  const navigate = useNavigate();
  const listenScrollEvent = () => {
    if (window.scrollY < 200) {
      return setShowScroller("none");
    } else if (window.scrollY > 200) {
      return setShowScroller("flex");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);
  const handleImageError = () => {
    setIsMoreInfoImageError(true);
  };

  const handleErrorOnImage = async () => {
    const payload = {
      image_name: imageid,
      shootid: shootId,
    };
    const response = await GetMagnifiedImage(payload);
    if (response) {
      setIsMoreInfoImageError(false);
      setErrorMoreInfoPage(response);
    } else {
      setIsMoreInfoImageError(true);
    }
  };

  useEffect(() => {
    if (isMoreInfoImageError === true) {
      handleErrorOnImage();
    }
  }, [isMoreInfoImageError]);
  let date=new Date();
  let newUrl=`${FullImageWall}?date=${date}`
  return (
    <>
      {(loading || isMoreInfoImageError) && <Loader />}
      <div className="main-container">
        <div>
          {isMoreInfoWall === true && (
            <>
              <div
                className={`${imageAlignment === "V"
                    ? "moreinfo-wallpaper-vertical"
                    : imageAlignment === "S"
                      ? "moreinfo-wallpaper-square"
                      : ""
                  } moreinfo-wallpaper show-image-menu-w-hover`}
              >
                <img
                  src={isMoreInfoImageError ? errorMoreInfoPage : newUrl}
                  style={{ display: "block" }}
                  alt={imageid}
                  loading="lazy"
                  onError={handleImageError}
                />
                <ImageMenu
                  handleCloseInfoPage={() => window.close()}
                  imageName={imageid}
                  shootId={shootId}
                  imageSno={imageSno}
                  isPrivilegeUser={isPrivilegeUser}
                  isInfoPage={true}
                  hasCloseButton={true}
                  imageAlignment={imageAlignment}
                />
              </div>
              <div className="moreinfo-image-text56">
                <div className="moreinfo-copyright-title">
                  This Image is Copyrighted by ImagesBazaar.
                </div>
                <div className="moreinfo-copyright-content">
                  The use of this image is subject to payment and compliance
                  with ImagesBazaar's License Agreement. Any non-compliance
                  amounts to copyright infringement, which is a very serious
                  civil and criminal offence allowing court to sentence you for
                  the imprisonment up to 3 years.
                </div>
              </div>
            </>
          )}
          {isStarsMoreInfo === true && (
            <>
              <div
                className={`${imageAlignment === "V" ? "moreinfo-wallpaper-vertical" : ""
                  } moreinfo-wallpaper show-image-menu-w-hover`}
              >
                <img
                  src={isMoreInfoImageError ? errorMoreInfoPage : FullImageWall}
                  style={{ display: "block" }}
                  alt={imageid}
                  loading="lazy"
                  onError={handleImageError}
                />
                <StarsImageMenu
                  imageName={imageid}
                  shootId={shootId}
                  isInfoPage={true}
                  imageSno={imageSno}
                  imageAlignment={imageAlignment}
                  hasImageCloseMenu={true}
                />
              </div>
              <div className="moreinfo-image-text56">
                <div className="moreinfo-copyright-title">
                  This Image is Copyrighted by ImagesBazaar.
                </div>
                <div className="moreinfo-copyright-content">
                  The use of this image is subject to payment and compliance
                  with ImagesBazaar's License Agreement. Any non-compliance
                  amounts to copyright infringement, which is a very serious
                  civil and criminal offence allowing court to sentence you for
                  the imprisonment up to 3 years.
                </div>
              </div>
            </>
          )}
          {isVideoMoreInfoWall === true && (
            <>
              <div
                className={`moreinfo-wallpaper show-image-menu-w-hover show-videomoreinfo`}
              >
                {/* <Vimeo
                  video={videoid}
                  responsive={true}
                  autoplay={true}
                  muted={true}
                /> */}
                <div style={{ position: "relative" }}>
                  <ReactPlayer
                    // url={`https://vimeo.com/${item?._source?.vimeo_id}`}
                    // url={`https://d3nn873nee648n.cloudfront.net/videos/${shootId}/${imageid}.mp4`}
                    // url={`${ApiConfig?.VIDEO_BASE_URL}${shootId}/${imageid}.mp4`}
                    url={`${ApiConfig?.VIDEO_BASE_URL}${shootId}/${imageid}.mp4`}


                    width='100%'
                    height='auto'
                    loop={true}
                    style={{
                      // position: "absolute",
                      // top: 0,
                      // left: 0
                    }}
                    // onError={() => {
                    //   handleVideoError();
                    // }}
                    controls={false}
                    playing={true}
                    muted={true}
                  />
                </div>
                <VideoMenu
                  imageName={imageid}
                  shootId={shootId}
                  videoSno={videoSno}
                  isInfoPage={true}
                  hasImageCloseMenu={true}
                  isMoreInfoVideo={true}
                  imageAlignment={"H"}
                />
              </div>
              <div className="moreinfo-image-text56">
                <div className="moreinfo-copyright-title">
                  This Video is Copyrighted by ImagesBazaar
                </div>
                <div className="moreinfo-copyright-content">
                  The use of this video is subject to payment and compliance
                  with ImagesBazaar's License Agreement. Any non-compliance
                  amounts to copyright infringement, which is a very serious
                  civil and criminal offence allowing court to sentence you for
                  the imprisonment up to 3 years.
                </div>
              </div>
            </>
          )}
          {!isMoreInfoWall && !isStarsMoreInfo && !isVideoMoreInfoWall && (
            <div className="main-common-header">
              <Header
                authUser={authUser}
                isStarsCollectionPage={isStarsCollectionPage}
                isSearchtext={isSearchtext}
                FullImageWall={FullImageWall}
              />
            </div>
          )}
          {hasBannerImage === true && (
            <div className="search-image-section">
              <CarouselComponent images={getDataFromAppSetting(
                appSettingData?.items?.features?.banner_images,
                "key_name",
                "homepage_banner"
              )[0]?.key_value} />
              {/* <img
                src={
                  getDataFromAppSetting(
                    appSettingData?.items?.features?.banner_images,
                    "key_name",
                    "homepage_banner"
                  )[0]?.key_value
                }
                className="homepage-hero-image"
                alt="Image Of Banner"
              /> */}

            </div>
          )}
          <div
            className="children-content"
            style={{
              marginTop: hasBannerImage
                ? ""
                : isMoreInfoWall === true ||
                  isStarsMoreInfo === true ||
                  isVideoMoreInfoWall === true ||
                  isSearchtext === false
                  ? "25px"
                  : "140px",
            }}
          >
            {children}
          </div>
        </div>
        <Footer />
        {isScrollDown && (
          <div
            className="arroe-to-scroll"
            style={{ display: showScroller }}
            onClick={() => {
              window.scroll({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <ArrowUpSide fill="white" width="18px" height="18px" />
          </div>
        )}
        <Tooltip
          title="Contact Us"
          arrow
          className="common-chat-tooltip"
          placement="left"
          sx={{
            backgroundColor: "#1900ff !important",
            color: "white !important",
          }}
        >
          <div
            className="chatbox-to-scroll"
            onClick={() => navigate("/contactus")}
          >
            <ChatIcon fill="white" width="23px" height="23px" />
          </div>
        </Tooltip>
      </div>
    </>
  );
};

export default Layout;
